import { render, staticRenderFns } from "./Papers.vue?vue&type=template&id=6bf97519&scoped=true&"
import script from "./Papers.vue?vue&type=script&lang=js&"
export * from "./Papers.vue?vue&type=script&lang=js&"
import style0 from "./Papers.vue?vue&type=style&index=0&id=6bf97519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf97519",
  null
  
)

export default component.exports